<template>
  <div class="spacer"></div>
</template>

<style lang="scss" scoped>
.spacer {
  margin: 0 auto;
}
</style>
